import { useEffect, useState } from "react"
import { Box, Chip, Grid, IconButton, Typography } from "@mui/material"
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { ButtonBasic, TableBase } from "../../components"
import { showModal } from "react-redux-modal-provider";
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import ConfirmationDialog from "../../modals/default/ConfirmationDialog";
import SubMotivoBajaService from "../../services/subMotivoBaja.service";
import ModalSubMotivoBaja from "../../modals/admTicket/ModalSubMotivoBaja";

const SubMotivoBajaScreen = () => {
    const [items, setItems] = useState([]);
    const actualizar = async() =>{
        await SubMotivoBajaService.getAll({all: true}).then((resp)=>{
            setItems(resp)
        })
    }

    const columns = [
        {
            name: "id_smb",
            label: "ID",
            options: {
                filter: false,
                sort: false,
                display:false,
                viewColumns: false
            }
        },
        {
            name: "nombre_smb",
            label: "Nombre",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "tipoCategoria_smb",
            label: "Tipo",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: 'isDeleted_smb',
            label: "Estado",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    if(!value){
                    return <Chip label="Activo" color="success" />
                    }
                    return <Chip label="Inactivo" color="error" />
                }
            }
        },
        {
            name: 'actions',
            label: "Acciones",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <>
                        <Box display='flex'>
                            <IconButton color='info' aria-label="edit" onClick={()=>onOpenEditar(tableMeta.rowData[0])}>
                                <EditIcon fontSize="medium" />
                            </IconButton>
                            <IconButton color='info' aria-label="edit" onClick={()=>onEliminar(tableMeta.rowData[0])}>
                                { !tableMeta.rowData[3] ?(
                                    <DeleteIcon fontSize="medium" sx={{color: 'red'}} />
                                ):(
                                    <PublishedWithChangesIcon fontSize="medium" sx={{color: 'green'}} />
                                )}
                            </IconButton>
                        </Box>
                    </>
                )
            }
        }
    ];
    const onGuardar = () => actualizar();
    const onOpenEditar = (item) => {
        if(item){
            const searchItem = items.find((sItem)=> sItem.id_smb === item)
            showModal(ModalSubMotivoBaja, {item: searchItem, onGuardar: onGuardar});
        }else{
            showModal(ModalSubMotivoBaja, {onGuardar: onGuardar});
        }
    };
    const onEliminar = (item) => {
        const searchItem = items.find((sItem)=> sItem.id_smb === item)
        showModal(ConfirmationDialog, {
            title: `${searchItem?.isDeleted_ptk ? 'Activar' : 'Eliminar'} la problematica`,
            message: `¿Esta seguro que desea ${searchItem?.isDeleted_ptk ? 'activar' : 'eliminar'} la problematica?`,
            onConfirm: async() => {
                await SubMotivoBajaService.destroy(searchItem.id_smb).then(() => {
                    onGuardar();
                });
            }
        });
    };
    useEffect(() => {
        actualizar();
        document.title = 'Sub-Motivo Baja';
    }, [])


    return (
        <Box sx={{width:'100%',height: '100%',overflow:'auto'}} className='side'>
            <Grid container p={3} display='flex' justifyContent='center'>
                <Grid item xs={6}>
                    <Typography className="text-gray-900 font-bold" variant="h2">Sub-Motivo Baja</Typography>
                </Grid>
                <Grid item xs={6} sx={{display: 'flex', justifyContent: 'end'}}>
                    <ButtonBasic
                        textButton="NUEVO"
                        sx={{width: 200, height: 30}}
                        onClick={()=>onOpenEditar()}
                        variant='wk'
                        color="nextStep"
                    />
                </Grid>
                <Grid item xs={12} md={6} mt={2} sx={{marginBottom: 15}}>
                    <TableBase title='Resultados' columns={columns} data={items} />
                </Grid>
            </Grid>
        </Box>
    )
}

export default SubMotivoBajaScreen